import axios from "api/axios";
import useAuth from "hooks/useAuth";

const useLogout = () => {
  const { setAuth, persist, setPersist } = useAuth();

  const logout = async () => {
    setAuth({ roles: {} });
    localStorage.removeItem("user");
    try {
      const response = await axios("/logout", {
        withCredentials: true,
      });
      if (response) {
        setPersist(false);
        localStorage.setItem("persist", persist);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return logout;
};

export default useLogout;
